import { FormattedMessage } from "react-intl"
import { FormTextInput } from "@/components/Form/FormTextInput"
import { FormDatePicker } from "@/components/Form/FormDatePicker"
import { type TransportDetailsFormInput } from "./TransportDetailsPanel"

export const LoadingDetails = () => {
    return <div
        className="display-flex gap-20 margin-bottom-15 align-items-center justify-content-center padding-20 bg-lightest">
        <div className="padding-x-20 text-center ">
            <span className="text-size-16 text-color-gray">
                <span className="rioglyph rioglyph-start text-size-200pct">
                </span>
            </span>
        </div>
        <div className={"flex-basis-100pct"}>
            <FormDatePicker<TransportDetailsFormInput>
                fieldName={"transportDetails.loading.loadedAt"}
                label={<FormattedMessage id={"freightPaymentDetails.loading.loadedAt"}/>}
                required={true}
                allowTime={false}
                allowFutureDates={false}
                validationMessageOverrides={{
                    required: <FormattedMessage id={"freightPaymentDetails.loading.loadedAt.required"}/>
                }}
            />
        </div>
        <div className={"flex-basis-100pct"}>
            <FormTextInput<TransportDetailsFormInput>
                fieldName={"transportDetails.loading.duns"}
                label={<FormattedMessage id={"freightPaymentDetails.loading.duns"}/>}
                required={true}
                mask={"000000000"}
                minLength={9}
                maxLength={9}
                validationMessageOverrides={{
                    required: <FormattedMessage id={"freightPaymentDetails.loading.duns.required"}/>
                }}
            />
        </div>
        <div className={"flex-basis-100pct"}>
            <FormTextInput<TransportDetailsFormInput>
                fieldName={"transportDetails.loading.supplierCode"}
                label={<FormattedMessage id={"freightPaymentDetails.loading.supplierCode"}/>}
                required={true}
                validationMessageOverrides={{
                    required: <FormattedMessage id={"freightPaymentDetails.loading.supplierCode.required"}/>
                }}
            />
        </div>
    </div>
}
